<template>
  <Breadcrumb
    :model="breadcrumbItems"
    class="p-0 border-none shadow-none flex flex-wrap items-center gap-2"
    :pt="{
      root: { class: 'bg-transparent' },
      item: { class: 'flex items-center' },
      itemicon: {
        class:
          'layout-menuitem-icon breadcrumb-icon !text-[#b91c1c] !text-2xl lg:!text-2xl mr-2',
      },
      itemlabel: {
        class:
          'breadcrumb-label text-primary font-medium text-xl sm:text-2xl lg:text-3xl',
      },
    }"></Breadcrumb>
</template>

<script setup lang="ts">
  import Breadcrumb from "primevue/breadcrumb"
  import type { MenuItem } from "primevue/menuitem"
  import { ref, watch } from "vue"
  import { useRoute } from "vue-router"
  import { breadcrumbFromRoute } from "./PrimeBreadcrumbAdapter"

  const route = useRoute()
  const breadcrumbItems = ref<MenuItem[]>([])

  function setBreadcrumbItems() {
    breadcrumbItems.value = breadcrumbFromRoute(route)
  }

  watch(
    route,
    () => {
      setBreadcrumbItems()
    },
    { immediate: true },
  )
</script>
